var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Accordion',{ref:"el",staticClass:"Qa",attrs:{"id":_vm.id,"markdown":_vm.answer,"title":(_vm.number + ". " + _vm.question)}})}
var staticRenderFns = []

export { render, staticRenderFns }